/* 📦 LIBS */
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { ImageProfile, SideBarItem, SideBarSubItem, SideBarLogout} from "./components";

/* 🧠 REDUX */
import { store } from "../../Redux/Store";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { ChangeTextVisibility } from "../../Redux/Actions";

/* 📁 ASSETS*/
import { ControlIcon, DashIcon, LogOutIcon, MaintenanceIcon, MapIcon, ReportIcon, AdmIcon, Config, SBDIcon } from "../../Assets/icons/MenuIcons";

/* 🎨 STYLES */
import { Container, Gradient, MenuHeader, MenuContent, MenuFooter, MenuDivisor } from "./styles";

const SideBar = () => {
    const navigate = useNavigate();
    const user = useSelector(state => state.userReducer);
    const visibility = useSelector(state => state.MenuReducer.visibility);
    const equipamento = useSelector(state => state.generalReducer.Equipament);
    const currentPage = window.location.pathname;

    const { t } = useTranslation();

    let Dashboard= [];
        
        Dashboard.push(
            {
                text: t("dashboards.sub-items.general.sidebar-title"),
                page: equipamento ? `/dashboard/${equipamento}` : `/dashboard`,
                locationFunction : () => {
                    equipamento? navigate(`/dashboard/${equipamento}`) : navigate(`/dashboard`);
                }
            }
        )
        Dashboard.push(
            {
                text: t("dashboards.sub-items.loss-control.sidebar-title"),
                page: '/dashboard/perdas',
                locationFunction : () => {
                    navigate('/dashboard/perdas');
                },
                disabled: !user?.user?.can?.includes('loss_control.sanep')
            }
        ) 

    let Administrativo = []
    // Adiciona os itens conforme as permissões
    // necessário alterar no menu mobile
        Administrativo.push(
            {
                text: t("administrative.sub-items.employees.sidebar-title"),
                page: '/adm/funcionarios',
                locationFunction : () => {
                    navigate('/adm/funcionarios');
                },
                disabled: !user?.user?.can?.includes('user.index')
            }
        )
        Administrativo.push(
            {
                text: t("administrative.sub-items.equipments.sidebar-title"),
                page: '/adm/equipamentos',
                locationFunction : () => {
                    navigate('/adm/equipamentos');
                },
                disabled: !user?.user?.can?.includes('equipment.index')
            }
        )
        Administrativo.push(
            {
                text: t("administrative.sub-items.logs.sidebar-title"),
                page: '/adm/logs',
                locationFunction : () => {
                    navigate('/adm/logs')
                },
                disabled: !user?.user?.can?.includes('log.index')
            }
        )
            

    let Reports = [];
    try {
        Reports.push(
            {
                text: t("reports.sub-items.history.sidebar-title"),
                page: '/historico/'+equipamento,
                locationFunction : () => {
                    navigate(`/historico/${equipamento}`);
                }
            }
        )
        Reports.push(
            {
                text: t("reports.sub-items.charts.sidebar-title"),
                page: '/historico/graphs',
                locationFunction : () => {
                    navigate(`/historico/graphs`);
                }
            }
        )
    } catch (error) {
        
    }

    let Maintenances = []
        Maintenances.push(
            {
                icon: MaintenanceIcon,
                text: 'Listagem',
                page: '/manutencoes',
                locationFunction: ()=> {navigate('/manutencoes')},
                disabled: !user?.user?.can?.includes('maintenance.view')
            }
        )
        Maintenances.push(
            {
                icon: ReportIcon,
                text: 'Relatórios',
                page: '/manutencoes/report',
                locationFunction: ()=> {navigate('/manutencoes/report')},
                disabled: !user?.user?.can?.includes('maintenance.view')
            }
        )


    const ADMIN_USERS = [
        "7d3ad31c-572c-4be2-811f-9b4f14a9564f",
        "182fbfd6-86ab-4fa2-b588-c12825c64361",
        "2123e214-6dde-4dc0-9911-41b17ff4b067",
        "310a93b7-a4d7-47c9-ad75-0ae389d7ff2d",
        "52984c5a-b903-4577-8131-a48981dc8ffb"
    ];

    let ConfigRoutes = [];

    if (ADMIN_USERS.includes(user?.user?.id)) {
        ConfigRoutes.push({
            text: "Commands",
            page: "/PartCommands",
            locationFunction: () => {
            navigate("/PartCommands");
            }
        });
        ConfigRoutes.push({
            text: "CommandsVariables",
            page: "/PartCommandsVariables",
            locationFunction: () => {
            navigate("/PartCommandsVariables");
            }
        });
        ConfigRoutes.push({
            text: "CommandsHasVariables",
            page: "/PartCommandsHasVariables",
            locationFunction: () => {
            navigate("/PartCommandsHasVariables");
            }
        });
        ConfigRoutes.push({
            text: "CommandsVariablesAlarms",
            page: "/PartCommandsVariablesAlarms",
            locationFunction: () => {
            navigate("/PartCommandsVariablesAlarms");
            }
        });
        ConfigRoutes.push({
            text: "EquipmentHasCommands",
            page: "/EquipmentHasPartsCommands",
            locationFunction: () => {
            navigate("/EquipmentHasPartsCommands");
            }
        });
        ConfigRoutes.push({
            text: "EncapsuledVariablesGroups",
            page: "/EncapsuledVariablesGroups",
            locationFunction: () => {
            navigate("/EncapsuledVariablesGroups");
            }
        });
        ConfigRoutes.push({
            text: "CommandsVariablesAcceptUnits",
            page: "/PartCommandsVariablesAcceptUnits",
            locationFunction: () => {
            navigate("/PartCommandsVariablesAcceptUnits");
            }
        });
        ConfigRoutes.push({
            text: "CommandsVariablesAcceptValues",
            page: "/PartCommandsVariablesAcceptValues",
            locationFunction: () => {
            navigate("/PartCommandsVariablesAcceptValues");
            }
        });
    }

    const isPerfilActive = currentPage?.includes('/perfil') || false;
    const isDashboardActive = currentPage?.includes('/dashboard') || false;
    const isControlActive = currentPage?.includes('/controle') || false;
    const isReportsActive = currentPage?.includes('/historico') || false;
    // const isMaintenanceActive = currentPage?.includes('/manutencoes') || false;
    const isAdminActive = currentPage?.includes('/funcionarios') || currentPage?.includes('/equipamentos')
                    || currentPage?.includes('/alocacoes') || currentPage?.includes('/grupos') || currentPage?.includes('/logs') || false;
    const isConfigActive = currentPage?.includes('/config-routes') || false;
    



    return(
        <Container 
            onMouseEnter={() => {
                store.dispatch(ChangeTextVisibility(true));
            }}
            onMouseLeave={() => {
                store.dispatch(ChangeTextVisibility(false));
            }}
            >
            <Gradient>
                <MenuHeader>
                    <ImageProfile Image={user?.user?.foto} username={user?.user?.nome} function={() => navigate("/perfil")} page={"/perfil"} select={isPerfilActive}></ImageProfile>
                </MenuHeader>

                <MenuContent>
                    <MenuDivisor> {visibility ? t("sidebar.divisor1") : ''} </MenuDivisor>

                    <SideBarItem Icon={SBDIcon} Text={t("sidebar.SBD-home")} visibility={visibility} function={() => window.location = 'https://webio.biosolvit.com/'} page = {'https://webio.biosolvit.com/'}/>

                    <MenuDivisor> {visibility ? t("sidebar.divisor2") : ''} </MenuDivisor>


                    <SideBarItem Icon={MapIcon} select={currentPage === '/'} Text={t("map.sidebar-title")} visibility={visibility} function={() => navigate("/")} page = {'/'}/>

                    {/* <SideBarItem Icon={DashIcon} select={currentPage.includes('/dashboard')} Text={t("dashboards.sidebar-title")} visibility={visibility}
                        function={() => equipamento? navigate(`/dashboard/${equipamento}`) : navigate(`/dashboard`)}
                        page = {equipamento ? `/dashboard/${equipamento}` : `/dashboard`}/> */}

                    <SideBarItem Icon={DashIcon} Text={t("dashboards.sidebar-title")}  visibility={visibility} select={isDashboardActive}>
                        <SideBarSubItem itens={Dashboard} active={isDashboardActive} select={isDashboardActive ? currentPage : ""}/>
                    </SideBarItem>
                   
                    <SideBarItem Icon={ControlIcon} select={isControlActive} Text={t("control.sidebar-title")}  visibility={visibility}
                        function={() => equipamento? navigate(`/controle/${equipamento}`) : navigate(`/controle`)}
                        page = {equipamento ? `/controle/${equipamento}` : `/controle`}/>
                    
                    <SideBarItem Icon={ReportIcon} Text={t("reports.sidebar-title")} visibility={visibility} select={isReportsActive}>
                        <SideBarSubItem itens={Reports} active={isReportsActive} select={isReportsActive ? currentPage : ""}/>
                    </SideBarItem>

                    {/* Manutenção escondida temporariamente: módulo não está em uso (rotas /manutencoes continuam ativas) */}
                    {/* <SideBarItem Icon={MaintenanceIcon} Text={t("maintenance.sidebar-title")} visibility={visibility} select={isMaintenanceActive}>
                        <SideBarSubItem itens={Maintenances} active={isMaintenanceActive} select={isMaintenanceActive ? currentPage : ""}/>
                    </SideBarItem> */}

                    <SideBarItem Icon={AdmIcon}  select={isAdminActive} Text={t("administrative.sidebar-title")} visibility={visibility}>
                            <SideBarSubItem itens={Administrativo} active={isAdminActive} select={isAdminActive ? currentPage : ""}/>
                    </SideBarItem>

                    {ADMIN_USERS.includes(user?.user?.id) &&
                        <SideBarItem Icon={Config} Text={t("config-routes.sidebar-title")} visibility={visibility} select={isConfigActive}>
                            <SideBarSubItem itens={ConfigRoutes} active={isConfigActive} select={isConfigActive ? currentPage : ""}/>
                        </SideBarItem>
                    }

                </MenuContent>

                <MenuFooter>
                    <SideBarLogout Icon={LogOutIcon} />
                </MenuFooter>
            </Gradient>
        </Container>
    )
}

export default SideBar;